import React from "react";
import PropTypes from "prop-types";

const Badge = ({ badgeText }) => {
  return <div className="badgeLink__holder--badge">{badgeText}</div>;
};

export default Badge;

Badge.propTypes = {
  badgeText: PropTypes.string
};

Badge.defaultProps = {
  badgeText: ""
};
